import * as React from 'react';
import { Col as BaseCol } from '@mc/react-core';
import classNames from 'classnames';
import { useTheme } from '../useTheme';

type Props = React.ComponentProps<typeof BaseCol> & {};

export const Col: React.FC<Props> = ({ className, ...other }) => {
  const theme = useTheme();
  const cls = classNames(`${theme.ns}-col`, className, {});

  return <BaseCol className={cls} {...other} />;
};
